import { Navigate, useLocation, useParams } from "react-router-dom";

type LegacyFinancialNotificationRedirectProps = {
  kind: "income" | "outcome";
};

const LegacyFinancialNotificationRedirect = ({
  kind,
}: LegacyFinancialNotificationRedirectProps) => {
  const { id } = useParams<{ id: string }>();
  const { search, hash } = useLocation();
  const listPath = kind === "income" ? "/financial/income" : "/financial/outcome";
  const target = id ? `${listPath}/${id}/edit${search}${hash}` : listPath;

  return <Navigate to={target} replace />;
};

export default LegacyFinancialNotificationRedirect;
